'use client';

/**
 * Stable per-install identifier used to address NOT-logged-in devices for push
 * and to dedupe a device across FCM token rotations. Persisted in localStorage
 * (WebView-backed on native, survives launches). Same `docupro:` key convention
 * as the FCM token keys in messaging.ts / NotificationProvider.tsx.
 */

const INSTALLATION_ID_KEY = 'docupro:installationId';

export function getInstallationId(): string {
  if (typeof window === 'undefined') return '';
  let id = window.localStorage.getItem(INSTALLATION_ID_KEY);
  if (!id) {
    id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(INSTALLATION_ID_KEY, id);
  }
  return id;
}
